import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90b90ff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  id: "myModalProduct",
  "data-target": ".bd-example-modal-lg"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header p-4",
  style: {"gap":"1rem","display":"flex"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div style=\"background-color:aliceblue;width:2rem;height:2rem;border-radius:8px;display:flex;align-items:center;justify-content:center;\" data-v-90b90ff2><svg width=\"24\" height=\"26\" viewBox=\"0 0 24 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-90b90ff2><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.2326 18.7901V8.82581L13.3154 14.5515C13.2932 14.5643 13.2708 14.5764 13.2481 14.5877V25.4995L22.5436 19.9984C22.9706 19.7457 23.2326 19.2863 23.2326 18.7901ZM10.4277 14.552L0.767395 8.97458V18.7906C0.767395 19.2868 1.02933 19.7462 1.45637 19.9989L10.7518 25.5V14.6829C10.6408 14.6554 10.5317 14.612 10.4277 14.552Z\" fill=\"#203972\" data-v-90b90ff2></path><path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.07086 6.26705C1.18886 6.11804 1.33779 5.99211 1.51143 5.89963L11.3399 0.664817C11.7525 0.445061 12.2474 0.445061 12.66 0.664817L22.4884 5.89963C22.6223 5.97092 22.7414 6.06209 22.8431 6.16838L12.0672 12.3898C11.9964 12.4307 11.9311 12.4775 11.8715 12.5292C11.812 12.4775 11.7467 12.4307 11.6758 12.3898L1.07086 6.26705Z\" fill=\"#203972\" data-v-90b90ff2></path></svg></div><h5 class=\"modal-title\" style=\"font-size:1rem;\" data-v-90b90ff2>Produtos da Loja</h5>", 2)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.5rem","font-weight":"bold","margin-bottom":"1rem","position":"absolute","top":"2px","left":"8px"} }, "x", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-body d-flex flex-column",
  style: {"background-color":"#D9D9D9","gap":"1rem","padding":"1rem","border-radius":"0rem  0rem 0.475rem 0.475rem"}
}
const _hoisted_10 = {
  key: 0,
  class: "card p-5"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loadingGrey",
  style: {"width":"100%","height":"2.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "loadingGreyAnimation",
    style: {"width":"50%","height":"2.5rem"}
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "col-12 card",
  style: {"border-radius":"8px","background-color":"#ffffff","display":"flex"}
}
const _hoisted_14 = {
  class: "d-flex col-md-12",
  style: {"padding":"1rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "col-md-6 d-flex flex-column justify-content-start align-items-start",
  style: {"border-right":"1px solid #D9D9D9"}
}
const _hoisted_16 = { style: {"font-size":"1.2rem","font-weight":"500","margin-bottom":"0"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1rem","font-weight":"400","margin-bottom":"0","opacity":"0.8"} }, "Loja", -1))
const _hoisted_18 = {
  class: "col-md-6 d-flex align-items-center justify-content-start",
  style: {"gap":"1rem"}
}
const _hoisted_19 = {
  key: 0,
  class: "d-flex align-items-center col-lg-10 p-3",
  style: {"gap":"1rem"}
}
const _hoisted_20 = { style: {"font-size":"1.5rem","margin-bottom":"0","font-weight":"600"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"1rem","margin-bottom":"0","font-weight":"500"} }, "Produtos vinculados", -1))
const _hoisted_22 = {
  key: 0,
  class: "fa fa-chevron-up chevronDownList"
}
const _hoisted_23 = {
  key: 1,
  class: "fa fa-chevron-down chevronDownList"
}
const _hoisted_24 = {
  key: 0,
  class: "col-md-12 p-0 h-100 flex-column",
  id: "listProductShow",
  style: {"border-top":"1px solid #D9D9D9","background-color":"#ffffff","border-radius":"0px 0px 8px 8px","display":"flex","padding":"1rem"}
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 d-flex justify-content-between align-items-center\" style=\"padding:1rem;\" data-v-90b90ff2><span class=\"text-muted col-2\" data-v-90b90ff2>SKU</span><span class=\"text-muted col-3\" data-v-90b90ff2>Categoria</span><span class=\"text-muted col-6\" data-v-90b90ff2>Nome</span><span class=\"text-muted col-1\" data-v-90b90ff2>Ações</span></div>", 1)
const _hoisted_26 = {
  key: 0,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Esta loja não possui vinculo")
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { style: {"min-height":"4rem"} }
const _hoisted_33 = { class: "col-2" }
const _hoisted_34 = { class: "col-3" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "btn btn-sm background_btn_1_opct",
  type: "button",
  disabled: ""
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "card" }
const _hoisted_43 = {
  class: "col-9",
  style: {"position":"relative"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil-alt",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem","margin":"0","color":"red","top":"1rem","padding":"0","position":"absolute","right":"1.5rem"}
}, null, -1))
const _hoisted_45 = { class: "col-3" }
const _hoisted_46 = {
  key: 0,
  type: "submit",
  class: "btn background_btn_1_opct col-12 d-flex justify-content-around align-items-center"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem","font-weight":"700","color":"red","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_48 = {
  key: 1,
  class: "btn background_btn_1_opct col-12 d-flex justify-content-around align-items-center",
  type: "button",
  disabled: ""
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"border-top":"1px solid #D9D9D9"} }, null, -1))
const _hoisted_51 = {
  key: 0,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Produto ja cadastrado na loja")
], -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 0,
  class: "col-3"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "SKU:", -1))
const _hoisted_59 = {
  key: 1,
  class: "col-6"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "SKU:", -1))
const _hoisted_61 = {
  key: 2,
  class: "col-6"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nome interno:", -1))
const _hoisted_63 = {
  key: 3,
  class: "col-3 d-flex flex-column"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Categoria:", -1))
const _hoisted_65 = {
  key: 4,
  class: "col-6 d-flex flex-column"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Categoria:", -1))
const _hoisted_67 = {
  key: 5,
  class: "col-2"
}
const _hoisted_68 = {
  class: "rounded border border-dark-subtle large my-0",
  style: {"height":"8rem","background-color":"#EFF2F5"}
}
const _hoisted_69 = ["src"]
const _hoisted_70 = {
  key: 6,
  class: "col-10"
}
const _hoisted_71 = {
  key: 7,
  class: "col-12"
}
const _hoisted_72 = { class: "col-6" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nome Comercial:", -1))
const _hoisted_74 = { class: "col-3" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Código Interno:", -1))
const _hoisted_76 = { class: "col-2" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Pontos:", -1))
const _hoisted_78 = { class: "col-1" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ordem:", -1))
const _hoisted_80 = { class: "col-12 d-flex justify-content-end align-items-center" }
const _hoisted_81 = {
  key: 0,
  type: "submit",
  class: "btn background_btn_1 mb-3 col-3",
  style: {"color":"white"}
}
const _hoisted_82 = {
  key: 1,
  class: "btn background_btn_1 mb-3 col-3",
  type: "button",
  style: {"color":"white"},
  disabled: ""
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSelectValues && _ctx.resetSelectValues(...args))),
              ref: "refModalDel",
              style: {"position":"relative"}
            }, _hoisted_8, 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.relationData?.fantasy_name), 1),
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.lenghtRealation), 1),
                            _hoisted_21
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "col-lg-2 d-flex align-items-center justify-content-center",
                            style: {"cursor":"pointer"},
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showListProductFunc && _ctx.showListProductFunc(...args)))
                          }, [
                            (_ctx.showListProduct)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                              : (_openBlock(), _createElementBlock("i", _hoisted_23))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.showListProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.relationDataInfo.length === 0 && _ctx.isLoading === false? true: false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                          : _createCommentVNode("", true),
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                          : _createCommentVNode("", true),
                        (!_ctx.isLoading)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.relationDataInfo, (product) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (_openBlock(), _createElementBlock("div", {
                                  key: product?.id,
                                  class: "col-md-12 d-flex justify-content-between align-items-center",
                                  style: {"padding":"1rem"}
                                }, [
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(product?.sku), 1),
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(product?.category?.name), 1),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(product?.name), 1),
                                  (!_ctx.isLoadingButton)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-sm background_btn_1_opct col-1",
                                        onClick: ($event: any) => (_ctx.deletRelation(product?.sku))
                                      }, _hoisted_38, 8, _hoisted_36))
                                    : _createCommentVNode("", true),
                                  (_ctx.isLoadingButton)
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_39, _hoisted_41))
                                    : _createCommentVNode("", true)
                                ]))
                              ]))
                            }), 256))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("form", {
                class: "row g-4 d-flex p-4",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitFunction && _ctx.onSubmitFunction(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imputProductData.sku) = $event)),
                    class: "form-control",
                    id: "inputPassword2",
                    placeholder: "Digite o sku do produto"
                  }, null, 512), [
                    [_vModelText, _ctx.imputProductData.sku]
                  ]),
                  _hoisted_44
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (!_ctx.isLoadingButtonSerach)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_46, [
                        _hoisted_47,
                        _createTextVNode(" Pesquisar ")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoadingButtonSerach)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_48, [
                        _hoisted_49,
                        _createTextVNode(" Carregando... ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 32),
              _createElementVNode("div", null, [
                _hoisted_50,
                (_ctx.isLoadingSku)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                  : _createCommentVNode("", true),
                (_ctx.badRequestShearchProduct && _ctx.isLoading === false? true: false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                  : _createCommentVNode("", true),
                (_ctx.imputProductData.isShowSku && !_ctx.isLoadingSku && !_ctx.badRequestShearchProduct)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 2,
                      class: "row g-3 p-4",
                      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitFunctionCreateProduct && _ctx.onSubmitFunctionCreateProduct(...args)), ["prevent"]))
                    }, [
                      (!_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _hoisted_58,
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.imputProductData.sku) = $event)),
                              style: {"color":"#9d9d9d"},
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, _ctx.imputProductData.sku]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.imputProductData.sku) = $event)),
                              style: {"color":"#9d9d9d"},
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, _ctx.imputProductData.sku]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _hoisted_62,
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.imputProductData.internalName) = $event)),
                              style: {"color":"#9d9d9d"},
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, _ctx.imputProductData.internalName]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _hoisted_64,
                            _createVNode(_component_el_select, {
                              id: "form-product-post-categoria",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              "reserve-keyword": false,
                              placeholder: "Selecione a categoria...",
                              class: "p-0",
                              style: {"margin-top":"0","width":"100%"},
                              modelValue: _ctx.imputProductData.category,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.imputProductData.category) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalRelationInfo, (el) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: el.id,
                                    value: el.id,
                                    label: el.name
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _hoisted_66,
                            _createVNode(_component_el_select, {
                              id: "form-product-post-categoria",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              "reserve-keyword": false,
                              placeholder: "Selecione a categoria...",
                              class: "p-0",
                              style: {"margin-top":"0","width":"100%"},
                              modelValue: _ctx.imputProductData.category,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.imputProductData.category) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalRelationInfo, (el) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: el.id,
                                    value: el.id,
                                    label: el.name
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("figure", _hoisted_68, [
                              _createElementVNode("img", {
                                src: _ctx.imputProductData.img,
                                style: {"height":"8rem","width":"100%"},
                                alt: ""
                              }, null, 8, _hoisted_69)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: "form-control text-body-secondary",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.imputProductData.description) = $event)),
                              placeholder: "Nãp possui descrição",
                              style: {"height":"8rem","resize":"none","color":"#9d9d9d"}
                            }, null, 512), [
                              [_vModelText, _ctx.imputProductData.description]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.imputProductData.isShowFormSkuWithoutProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: "form-control text-body-secondary",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.imputProductData.description) = $event)),
                              placeholder: "Descrição do produto",
                              style: {"height":"6rem","resize":"none","color":"#9d9d9d"}
                            }, null, 512), [
                              [_vModelText, _ctx.imputProductData.description]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.imputProductData.name) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.imputProductData.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.imputProductData.internalCode) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.imputProductData.internalCode]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _hoisted_77,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.imputProductData.point) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.imputProductData.point]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _hoisted_79,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.imputProductData.order) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.imputProductData.order]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        (!_ctx.isLoadingButtonAddProduct)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_81, "Adicionar"))
                          : _createCommentVNode("", true),
                        (_ctx.isLoadingButtonAddProduct)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_82, [
                              _hoisted_83,
                              _createTextVNode(" Carregando... ")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}